import styled from '@emotion/styled';

export const MainBlock = styled.div`
  min-height: calc(100vh - 70px);
  padding-top: 24px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    height: calc(100vh - 56px);
    padding-top: 12px;
    gap: 16px;
  }
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
  padding-inline: 24px;

  @media (max-width: 768px) {
    padding-inline: 12px;
    padding-bottom: 12px;
    gap: 12px;
  }

  &::-webkit-scrollbar {
    width: 7px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbcbcb;
    border-radius: 8px;
  }
`;

export const FiltersBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  padding-inline: 24px;

  @media (max-width: 768px) {
    padding-inline: 12px;
    gap: 12px;
  }
`;
